import React, { FC } from 'react';
import { LoginView } from '../components';
import {ThemeProvider} from "@mui/material";
import {adminTheme} from "../../../themes";

export const LoginPage: FC = () => {
  return <ThemeProvider theme={adminTheme}><LoginView /></ThemeProvider>;
};
